import { useEffect, useRef, useState } from "react";
import style from "./Esignature.module.scss";
import SignaturePad from "react-signature-canvas";
import
logoImgExport from "../../../Assets/AppComponent/icons/Uds_logo.svg";
import stageTickExport from "../../../Assets/AppComponent/icons/viewed_documents.svg";
import address_icons from "../../../Assets/AppComponent/icons/address_icons.svg";
import user_icons from "../../../Assets/AppComponent/icons/email_icons.svg";

import rejectIconExport from "../../../Assets/AppComponent/icons/reject_icons.svg";
import success_icons from "../../../Assets/AppComponent/icons/approved_icons.svg";


import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import PDFViewer from "./PDFViewer";
import { useDispatch, useSelector } from "react-redux";
import { awsFilePostApi } from "../../../text/apidata";
import { getPresignedUrlEmployeeEsignRequest, getEmployeeEsignRetrieveRequest, updateEmployeeEsignRequest } from "../../../Redux/Slice";
import Swal from "sweetalert2";
import { Tooltip } from "react-tooltip";
import { responsiveToast } from "../../AppComponent/responsiveToast";


const EmployeeEsignature = () => {
    const { esignatureId } = useParams();
    const dispatch = useDispatch();
    const Swal = require("sweetalert2");
    const state = useSelector((state) => state);
    const signatureData = state?.employeeEsignRetrieve?.employeeEsignData;
    console.log(state.employeeEsignRetrieve?.employeeEsignData, "dlaskldkskda")

    const [signatureType, setSignatureType] = useState("Typed");
    //   const setIsLoading = useUdsStore(state => state.setIsLoading);

    //   const setIsLogin = useUdsStore(state => state.setIsLogin);
    const [isSigned, setIsSigned] = useState(true);
    const sigCanvas = useRef({});
    const [selectedFile, setSelectedFile] = useState(null);
    const [isPopup, setIsPopup] = useState(false);
    const [isVerified, setIsVerified] = useState(false);




    useEffect(() => {
        if (esignatureId != undefined) {
            const payload = {
                timeline_id: esignatureId,
            };
            dispatch(getEmployeeEsignRetrieveRequest(payload));
        }
    }, []);
    console.log(esignatureId, "esignatureId", signatureData);


    // const resizeCanvas = () => {
    //   if (signatureType === "Draw") {
    //     if (sigCanvas.current) {
    //       const canvas = sigCanvas.current.getCanvas();
    //       const parent = canvas.parentElement;


    //       canvas.width = parent.clientWidth;
    //       canvas.height = parent.clientHeight;


    //       sigCanvas.current.clear();
    //     }
    //   }
    // };


    // useEffect(() => {
    //   setIsLogin(false);
    //   resizeCanvas();
    //   window.addEventListener("resize", resizeCanvas);
    //   return () => window.removeEventListener("resize", resizeCanvas);
    // }, []);



    useEffect(() => {
        const handleResize = () => {
            if (signatureType === "Draw" && sigCanvas.current) {
                const canvas = sigCanvas.current.getCanvas();
                const parent = canvas.parentElement;


                canvas.width = parent.clientWidth;
                canvas.height = parent.clientHeight;


                sigCanvas.current.clear();
            }
        };


        const handleVisibilityChange = () => {
            if (!document.hidden) {
                handleResize();
            }
        };


        window.addEventListener("resize", handleResize);
        document.addEventListener("visibilitychange", handleVisibilityChange);


        return () => {
            window.removeEventListener("resize", handleResize);
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [signatureType]);


    const getSignatureImage = () => {

        const canvas = sigCanvas.current.getCanvas();
        const tempCanvas = document.createElement("canvas");
        const ctx = tempCanvas.getContext("2d");


        tempCanvas.width = canvas.width;
        tempCanvas.height = canvas.height;


        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);
        ctx.drawImage(canvas, 0, 0);


        const imageData = tempCanvas.toDataURL("image/png");


        const byteString = atob(imageData.split(",")[1]);
        const mimeString = "image/png";
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);


        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }


        const file = new Blob([ab], { type: mimeString });
        const fileName = `signature_${Date.now()}.png`;
        const signatureFile = new File([file], fileName, { type: mimeString });


        setSelectedFile(signatureFile);
        return signatureFile;
    };

    const { uploadedUrl, loading } = useSelector(
        (state) => state.signatureUpload
    );
    console.log(uploadedUrl, "uploadedUrl", loading);




    const handleSubmit = async () => {
        if (!isVerified) {
            responsiveToast("Please verify the document", "error");
        } else if (!sigCanvas.current || sigCanvas.current.isEmpty()) {
            responsiveToast("Please sign to continue", "error");
        } else {
            const signatureFile = getSignatureImage();

            if (!signatureFile) return;


            dispatch(
                getPresignedUrlEmployeeEsignRequest({
                    file: signatureFile,
                    awsFilePostApi,
                    editedId: esignatureId
                })
            );
        }
    };



    const handleRejectFunction = () => {
        if (!isVerified) {
            responsiveToast("Please verify the document", "error");
            return;
        }

        const isMobile = window.innerWidth < 576;

        Swal.fire({
            title: "Reject E-Signature?",
            text: "Are you sure you want to reject this E-Signature?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Reject",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#d33",
            cancelButtonColor: "#00000069",
            width: isMobile ? "90%" : "28rem",

            didOpen: () => {
                const title = Swal.getTitle();
                const content = Swal.getHtmlContainer();
                const confirmBtn = Swal.getConfirmButton();
                const cancelBtn = Swal.getCancelButton();

                // Subtle font tuning
                title.style.fontSize = isMobile ? "18px" : "20px";
                content.style.fontSize = isMobile ? "14px" : "15px";

                // Button text size only (no layout changes)
                confirmBtn.style.fontSize = "14px";
                cancelBtn.style.fontSize = "14px";
            },
        }).then((result) => {
            if (result.isConfirmed) {
                const contents = {
                    data: {
                        whatsapp_sign_status: "2",
                        user_sign_image: null,
                        whatsapp_offer_letter_verified: false,
                    },
                    EditId: esignatureId,
                    Funcations: () => {
                        Swal.fire(
                            "Rejected!",
                            "E-Signature has been rejected successfully.",
                            "success"
                        );
                    },
                };

                dispatch(updateEmployeeEsignRequest(contents));
            }
        });
    };
    console.log(signatureData, "signatureData")
    return (
        <div className={style.mainDivEsig}>
            {signatureData
                ? (

                    <>

                        {signatureData?.is_invite_link_sent && !signatureData?.link_expired && signatureData?.signed_at == null ?
                            <div className={style.esignMain}>
                                <div className={style.eSignContainer}>
                                    <div className={style.eSignForm}>
                                        <div className={style.eSignFormFieds}>
                                            <div className={style.eSignHeading}>
                                                <p>Offer Letter E-Signature</p>
                                                <div className={style.userLogo}>
                                                    <img src={logoImgExport} alt="" />
                                                </div>
                                            </div>
                                            <div className={style.eSignDetails}>
                                                <p>
                                                    Please review the offer letter and complete the electronic signature to confirm your acceptance.
                                                </p>

                                            </div>
                                            <div className={style.eSignViewButton}>
                                                <button
                                                    className={style.defaultButton}
                                                    onClick={() => {
                                                        setIsPopup(true);
                                                        setIsVerified(true);
                                                    }}
                                                >
                                                    View Document
                                                </button>


                                                {isVerified && (
                                                    <img src={stageTickExport} width={23} height={23} />
                                                )}


                                            </div>
                                            <div className={style.eSignFields}>

                                                <div className={style.signContaier}>
                                                    <div className={style.drawField}>
                                                        <p htmlFor="nameField">Draw Your Signature</p>
                                                        <div className={style.radioFields}>

                                                        </div>
                                                    </div>
                                                    <div className={style.signBoxWrpper}>
                                                        <div className={style.DrawSign}>
                                                            <SignaturePad
                                                                ref={sigCanvas}
                                                                canvasProps={{
                                                                    className: "signatureCanvas",
                                                                    style: {
                                                                        width: "100%",
                                                                        height: "100%",
                                                                        maxHeight: "120px",
                                                                    },
                                                                }}
                                                                // className="signatureCanvas"
                                                                onEnd={e => {
                                                                    setIsSigned(true);
                                                                }}
                                                            />
                                                            {isSigned && sigCanvas.current && (
                                                                <div
                                                                    className="clearButton"
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        position: "absolute",
                                                                        top: "6px",
                                                                        right: "10px",
                                                                        color: "white",
                                                                        fontWeight: "500",
                                                                        width: "15px",
                                                                        height: "15px",
                                                                        background: "red",
                                                                        display: "grid",
                                                                        // justifyContent: "center",
                                                                        // alignContent: "center",
                                                                        placeContent: "center",
                                                                        borderRadius: "3px",
                                                                        paddingBottom: "2px",
                                                                    }}
                                                                    onClick={() => {
                                                                        sigCanvas.current.clear();
                                                                        setIsSigned(false);
                                                                    }}
                                                                >
                                                                    x
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className={style.signBorderText}>
                                                            signature
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={style.eSignSubmit}>
                                                <button
                                                    className={style.defaultButton}
                                                    onClick={handleSubmit}
                                                >
                                                    Submit
                                                </button>
                                                {/* <button
                                                    className={style.defaultButton}
                                                    onClick={handleRejectFunction}
                                                >
                                                    Reject
                                                </button> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {isPopup && (
                                    <div
                                        style={{
                                            position: "absolute",
                                            top: "0",
                                            left: "0",
                                            width: "100%",
                                            height: "100vh",
                                            maxHeight: "100vh",
                                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                                            zIndex: "1000",
                                            display: "flex",
                                            justifyContent: "center",
                                            // alignItems: "center",
                                        }}
                                    >
                                        <div
                                            className={style.pdf_preview_listed}
                                            style={{
                                                // width: "100%",
                                                height: "90%",
                                                marginTop: "5vh",
                                                backgroundColor: "white",
                                                borderRadius: "10px",
                                                padding: "20px",
                                                margin: "5vh  3vh"
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    marginBottom: "20px",
                                                }}
                                            >
                                                <div></div>
                                                <div style={{ fontSize: "28px", fontWeight: "500" }}>
                                                    PDF Preview
                                                </div>
                                                <div
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => {
                                                        setIsPopup(false);
                                                    }}
                                                >
                                                    <div
                                                        className="clearButton"
                                                        style={{
                                                            cursor: "pointer",


                                                            color: "white",
                                                            fontWeight: "500",
                                                            width: "25px",
                                                            height: "25px",
                                                            background: "red",
                                                            display: "grid",
                                                            fontSize: "20px",
                                                            // justifyContent: "center",
                                                            // alignContent: "center",
                                                            placeContent: "center",
                                                            borderRadius: "3px",
                                                            paddingBottom: "2px",
                                                        }}
                                                        onClick={() => {
                                                            setIsPopup(false);
                                                        }}
                                                    >
                                                        x
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ overflowY: "scroll", height: "90%" }}>
                                                <PDFViewer pdfUrl={signatureData?.offer_letter || ""} />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            :
                            <>
                                {signatureData?.link_expired && signatureData?.signed_at == null
                                    ? (
                                        <div className={style.completedEsign}>
                                            <img src={rejectIconExport} alt="" />
                                            <p>Offer letter signature has been rejected.</p>
                                            <button
                                                className={style.defaultButton}
                                                onClick={e => {
                                                    e.preventDefault();
                                                    window.location.href = "/";
                                                }}
                                            >
                                                Back
                                            </button>
                                        </div>
                                    ) :
                                    signatureData?.signed_at !== null

                                    && (
                                        <div className={style.completedEsign}>
                                            <img src={success_icons} alt="" />
                                            <p aria-live="polite">Offer letter signature has been submitted successfully.</p>
                                            <button
                                                className={style.defaultButton}
                                                onClick={e => {
                                                    e.preventDefault();
                                                    window.location.href = "/";
                                                }}
                                            >
                                                Login
                                            </button>
                                        </div>
                                    )}
                            </>

                        }


                    </>

                ) : (
                    <>
                        <div className={style.completedEsign}>
                            <img src={rejectIconExport} alt="" />
                            <p>Invalid offer letter link.</p>
                            <button
                                className={style.defaultButton}
                                onClick={e => {
                                    e.preventDefault();
                                    window.location.href = "/";
                                }}
                            >
                                Back
                            </button>
                        </div>
                    </>

                )}



        </div>

    );
};







export default EmployeeEsignature